import type { Asset } from 'src/types/TAssets';
import type { StoryboardSource } from './StoryboardStrip';

/**
 * What the strip and viewer need, from an asset's `/data`. Null when the
 * asset has no usable storyboard (none, empty, or errored).
 */
export const storyboardSourceFor = (
  asset: Asset,
  { mode, jwt }: { mode?: string; jwt?: string } = {},
): StoryboardSource | null => {
  const storyboard = asset.conversions?.storyboard;
  if (!storyboard?.file_count || asset.errors?.storyboard) return null;
  return {
    assetId: asset.id,
    count: storyboard.file_count,
    aspect: storyboard.width && storyboard.height ? storyboard.width / storyboard.height : 16 / 9,
    durationSeconds: asset.metadata?.duration,
    mode,
    jwt,
  };
};
